document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mainNav = document.querySelector('[data-main-nav]');

  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', () => {
      const open = mainNav.classList.toggle('main-nav-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.textContent = open ? 'Close' : 'Menu';
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const productPage = form.closest('[data-product-page]') || document;
    const price = productPage.querySelector('[data-product-price]');
    const comparePrice = productPage.querySelector('[data-product-compare-price]');
    const inventory = form.querySelector('[data-inventory-status]');
    const quantity = form.querySelector('[data-quantity-input]');
    const expressCheckout = form.querySelector('.shopify-payment-button');
    const optionGroups = Array.from(form.querySelectorAll('[data-option-position]'));
    const gallery = productPage.querySelector('[data-product-gallery]');
    const mainImage = gallery?.querySelector('[data-product-main-image]');

    if (!variantSelect || !addButton) return;

    const showGalleryImage = (imageUrl, imageAlt, imageId) => {
      if (!mainImage || !imageUrl) return;
      mainImage.src = imageUrl;
      mainImage.alt = imageAlt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.setAttribute('aria-pressed', String(thumb.dataset.imageId === imageId));
      });
    };

    gallery?.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showGalleryImage(thumb.dataset.imageUrl, thumb.dataset.imageAlt, thumb.dataset.imageId);
      });
    });

    const updateVariant = () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const inventoryManaged = option.dataset.inventoryManaged === 'true';
      const inventoryQuantity = Number(option.dataset.inventoryQuantity || 0);

      addButton.disabled = !available;
      if (expressCheckout) expressCheckout.hidden = !available;
      const addText = addButton.querySelector('[data-add-text]');
      if (addText) addText.textContent = available ? 'Add to bag' : 'Sold out';

      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }

      if (inventory) {
        if (!available) {
          inventory.textContent = 'Sold out';
        } else if (inventoryManaged && inventoryQuantity > 0 && inventoryQuantity <= 5) {
          inventory.textContent = `Only ${inventoryQuantity} left`;
        } else if (inventoryManaged) {
          inventory.textContent = 'In stock';
        } else {
          inventory.textContent = 'Available';
        }
      }

      if (quantity && inventoryManaged && inventoryQuantity > 0) {
        quantity.max = String(inventoryQuantity);
      } else if (quantity) {
        quantity.removeAttribute('max');
      }

      optionGroups.forEach((group) => {
        const chosenValue = option.dataset[`option${group.dataset.optionPosition}`];
        group.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.checked = radio.value === chosenValue;
        });
      });

      if (option.dataset.imageUrl) {
        showGalleryImage(option.dataset.imageUrl, option.dataset.imageAlt, option.dataset.imageId);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };

    optionGroups.forEach((group) => group.addEventListener('change', () => {
      const chosenValues = optionGroups.map((item) => item.querySelector('input:checked')?.value || '');
      const matchingOption = Array.from(variantSelect.options).find((option) =>
        chosenValues.every((value, index) => value === option.dataset[`option${index + 1}`])
      );

      if (matchingOption) {
        variantSelect.value = matchingOption.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        addButton.disabled = true;
        if (expressCheckout) expressCheckout.hidden = true;
        const addText = addButton.querySelector('[data-add-text]');
        if (addText) addText.textContent = 'Unavailable';
        if (inventory) inventory.textContent = 'This combination is unavailable';
        if (price) price.textContent = '—';
        if (comparePrice) comparePrice.hidden = true;
      }
    }));

    form.addEventListener('submit', (event) => {
      if (addButton.disabled) event.preventDefault();
    });

    variantSelect.addEventListener('change', updateVariant);
    updateVariant();
  });

  const supportPanel = document.querySelector('[data-support-panel]');
  const supportOpeners = document.querySelectorAll('[data-support-open]');
  const supportClose = document.querySelector('[data-support-close]');
  const supportMessages = document.querySelector('[data-support-messages]');
  const supportForm = document.querySelector('[data-support-form]');
  const supportInput = document.querySelector('[data-support-input]');

  const setSupportOpen = (open) => {
    if (!supportPanel) return;
    supportPanel.hidden = !open;
    supportOpeners.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (open && supportInput) supportInput.focus();
  };

  supportOpeners.forEach((button) => button.addEventListener('click', () => setSupportOpen(true)));
  if (supportClose) supportClose.addEventListener('click', () => setSupportOpen(false));

  const addMessage = (from, text) => {
    if (!supportMessages) return;
    const message = document.createElement('p');
    message.className = `chat-message ${from}`;
    message.textContent = text;
    supportMessages.appendChild(message);
    supportMessages.scrollTop = supportMessages.scrollHeight;
  };

  document.querySelectorAll('[data-support-question]').forEach((button) => {
    button.addEventListener('click', () => {
      addMessage('visitor', button.dataset.supportQuestion || '');
      addMessage('agent', button.dataset.supportAnswer || '');
    });
  });

  if (supportForm && supportInput) {
    supportForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const question = supportInput.value.trim();
      if (!question) return;

      const normalized = question.toLowerCase();
      let answer = 'For help with that, email orders@badmuttclothingco.com and a person will follow up.';
      if (normalized.includes('usa') || normalized.includes('american')) {
        answer = 'Trusted American factories cut and sew every Bad Mutt garment in the USA. Bad Mutt handles the inking and decorating in Odessa, Texas. Most use U.S.-sourced materials; any product with imported materials or components will be clearly labeled.';
      } else if (normalized.includes('custom') || normalized.includes('partner')) {
        answer = 'Bad Mutt accepts limited custom work for select organizations. Email orders@badmuttclothingco.com to inquire.';
      }

      addMessage('visitor', question);
      addMessage('agent', answer);
      supportInput.value = '';
    });
  }
});
